import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BallotDetails {
  BallotLevel?: any;
  BallotType?: any;
  BallotSubType?: any;
  BallotStatus?: any;
  RecordType?: any;
  RecordSubType?: any;
  AccreditationBody?: any;
  Committee?: any;
  Note?: string;
  NoOfRecords: number,
  Explaination: string,
  Description: string,
  DaysToIssue: number,
  OpenDate: string,
  CloseDate: string,
  BallotNumber: string,
  IsSecreteBallot: boolean,
  RecirculationBallotId: null,
  RecirculationBallotNumber: null,
  BallotCloserRemark: null,
  BallotClosedDate: null,
  Title: string,
  BallotMembershipPositions: any,
  Id: string,
  TenantId: string,
  Active: boolean,
  Deleted: boolean,
  CreatedBy: string,
  ModifiedBy: string,
  CreatedDate: string,
  ModifiedDate: string,
  IsDirty: boolean,
  IsNew: boolean,
  Success: boolean,
  SysMessages: null,
  SysMessagesKey: null,
  SysMessagesType: null,
  BallotFullAccess: boolean,
  CanCreateBallot: boolean,
  CanViewBallotDetail: boolean,
  CanUpdateBallot: boolean,
  CanViewVoteSummary: boolean,
  CanUpdateVote: boolean,
  CanAddVote: boolean,
  CanAddComment: boolean,
  CanViewComment: boolean,
  CanRespondToComment: boolean,
  CanUpdateComment: boolean,
  CanAddCommentOnBehalf: boolean,
  CanUpdateCommentOnBehalf: boolean,
  CanViewBallotReportAndResult: boolean,
  CanAddVoteOnBehalf: boolean,
  CanUpdateVoteOnBehalf: boolean,
  CanCancelBallot: boolean,
  CanViewAllBallot: boolean,
  CanDownloadBallotResultsAndReport: boolean | null,
  CanUpdateGlobalConfigCommittees: boolean,
  CanReplyToComment: boolean,
  AlfrescoStatusId: string,
  [key: string]: any; // For additional dynamic properties
}

interface BallotState {
  selectedBallotDetails: BallotDetails | null;
}

const initialState: BallotState = {
  selectedBallotDetails: null,
};

const selectedballotDetailsSlice = createSlice({
  name: "ballot",
  initialState,
  reducers: {
    setSelectedBallotDetails: (state, action: PayloadAction<BallotDetails>) => {
      state.selectedBallotDetails = action.payload;
    },
    updateSelectedBallotField: (
      state,
      action: PayloadAction<{ field: string; value: any }>
    ) => {
      if (state.selectedBallotDetails) {
        state.selectedBallotDetails[action.payload.field] = action.payload.value;
      }
    },
    clearBallotDetails: (state) => {
      state.selectedBallotDetails = null;
    },
  },
});

export const { setSelectedBallotDetails, updateSelectedBallotField, clearBallotDetails } =
  selectedballotDetailsSlice.actions;

export default selectedballotDetailsSlice.reducer;